export default "__VITE_PUBLIC_ASSET__e4101ab2__"